import React, { Fragment, useEffect, useState } from "react";
import "./Dropdown.css";

const allStatus = [
  {
    name: "Pending",
    icon: "/images/icons/status-icon-1.png",
  },
  {
    name: "Processing",
    icon: "/images/icons/status-icon-2.png",
  },
  {
    name: "Complete",
    icon: "/images/icons/status-icon-3.png",
  },
  {
    name: "Cancelled",
    icon: "/images/icons/status-icon-4.png",
  },
];

const ChangeStatus = ({ onTypeChange, status, getStatusImage }) => {
  const [isStatusActive, setIsStatusActive] = useState(false);
  const [statusSelected, setStatusSelected] = useState(status);
  const [selectedStatusImg, setSelectedStatusImg] = useState(getStatusImage);

  useEffect(() => {
    setStatusSelected(status);
    setSelectedStatusImg(getStatusImage);
  }, [status, getStatusImage]);

  const filteredOptions = () => {
    if (status === "Processing") {
      return allStatus.filter(
        (option) => option.name === "Complete" || option.name === "Cancelled"
      );
    } else if (status === "Complete") {
      return allStatus.filter((option) => option.name === "Cancelled");
    } else if (status === "Pending") {
      return allStatus.filter(
        (option) =>
          option.name === "Processing" ||
          option.name === "Complete" ||
          option.name === "Cancelled"
      );
    } else {
      return allStatus; // Show all options by default
    }
  };

  const optionsToShow = status === "Cancelled" ? [] : filteredOptions();

  return (
    <>
      <div className="select-box-wrapper">
        <div className="react-dropdown">
          <div
            className="react-dropdown-btn"
            onMouseEnter={(e) => {
              e.stopPropagation();
              setIsStatusActive(true);
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              setIsStatusActive(false);
            }}
          >
            <div className="selected-item">
              {statusSelected !== "All" && (
                <img src={selectedStatusImg} alt="img" />
              )}
              <p>{statusSelected}</p>
            </div>

            <img
              className={
                isStatusActive
                  ? "dropdown-down-arrow rotate-arrow"
                  : "dropdown-down-arrow"
              }
              src="/images/icons/dropdown-arrow.svg"
              alt="arrow"
            />
          </div>
          <div
            className="dropdown-space-manage"
            onMouseEnter={(e) => {
              e.stopPropagation();
              setIsStatusActive(true);
            }}
            onMouseLeave={(e) => {
              e.stopPropagation();
              setIsStatusActive(false);
            }}
          ></div>
          {isStatusActive && (
            <div
              className="dropdown-content"
              onMouseEnter={(e) => {
                e.stopPropagation();
                setIsStatusActive(true);
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                setIsStatusActive(false);
              }}
            >
              {optionsToShow.map((option, index) => {
                return (
                  <Fragment key={index}>
                    <div
                      onClick={(e) => {
                        setStatusSelected(option.name);
                        setIsStatusActive(false);
                        setSelectedStatusImg(option.icon);
                        onTypeChange(option.name); // Call callback function
                      }}
                      className={
                        option.name === statusSelected
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      <div className="dropdown-options">
                        <img src={option.icon} alt="icon" />
                        <p
                          className={`${
                            option.name === statusSelected
                              ? "option-active"
                              : "option-normal"
                          }`}
                        >
                          {option.name}
                        </p>
                      </div>
                    </div>
                  </Fragment>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChangeStatus;
